import { getOrderHistory } from 'entities/orderHistory/api/getOrderHistory'

export const OrderHistoryApi = {
    getOrderHistory,
}
